jQuery(function($){
  $('.works-listing-filters select').each(function(){
    var placeholder = $(this).attr('data-placeholder');
    $(this).select2({
      minimumResultsForSearch: -1,
      placeholder: placeholder,
      allowClear: true
    });
  });
  $('#product-filter, #color-filter').on('change', function(){
    var product_id = $('#product-filter').val();
    var color_id = $('#color-filter').val();
    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: {
        'action': 'get_works_by_category',
        'product': product_id,
        'color': color_id
      }
    }).done(function(response){
      var res = JSON.parse(response);
      $('.works-listing-grid .sv-g').html(res.content);
      initWorksPopin($);
    });
  });
  $('.works-listing-filters__reset').on('click', function(){
    $('#product-filter').val('').trigger('change');
    $('#color-filter').val('').trigger('change');
  });
});
